<template>
  <Dialog v-model:visible="showModal"
          :draggable="false"
          modal
          :header="isEdit ? `Upraviť ponuku (${state?.id})` : `Pridať do ponuky`"
          position="top"
          :style="{ width: '100%','max-width':'80%' }"
  >

    <div class="flex items-center justify-between">

      <b class="text-surface-500">
        Bude dostupný pre reštauraciu v :
      </b>

      <SelectButton v-model="state.restaurantPlace"
                    :options="options"
                    aria-labelledby="basic"
                    size="small"
                    option-value="value"
                    optionLabel="name"
      />


    </div>

    <hr class="my-4">

    <div class="flex mt-2 space-x-3">

      <div class="w-[320px]">
        <div class="flex  shrink-0 flex-col mt-2 gap-1">
          <label class="text-surface-500 text-sm" for="title">Názov sk</label>
          <InputText id="title" v-model="state.title" size="small"/>
        </div>

        <div class="flex  shrink-0 flex-col mt-2 gap-1">
          <label class="text-surface-500 text-sm" for="title">Názov cz</label>
          <InputText id="title" v-model="state.title_cz" size="small"/>
        </div>

        <div class="flex  shrink-0 flex-col mt-2 gap-1">
          <label class="text-surface-500 text-sm" for="title">Názov en</label>
          <InputText id="title" v-model="state.title_cz" size="small"/>
        </div>

        <div class="flex  shrink-0 flex-col mt-2 gap-1">
          <label class="text-surface-500 text-sm" for="title">Názov de</label>
          <InputText id="title" v-model="state.title_cz" size="small"/>
        </div>

        <div class="flex w-[320px] flex-col mt-2 gap-1 shrink">
          <label class="text-surface-500 text-sm" for="title">Text sk</label>
          <Textarea v-model="state.text" rows="5" cols="30"/>
        </div>

        <div class="flex w-[320px] flex-col mt-2 gap-1 shrink">
          <label class="text-surface-500 text-sm" for="title">Text< cz</label>
          <Textarea v-model="state.text_cz" rows="5" cols="30"/>
        </div>

        <div class="flex w-[320px] flex-col mt-2 gap-1 shrink">
          <label class="text-surface-500 text-sm" for="title">Text< en</label>
          <Textarea v-model="state.text_en" rows="5" cols="30"/>
        </div>

        <div class="flex w-[320px] flex-col mt-2 gap-1 shrink">
          <label class="text-surface-500 text-sm" for="title">Text< de</label>
          <Textarea v-model="state.text_de" rows="5" cols="30"/>
        </div>

        <div class="flex flex-col shrink mt-2 gap-1">
          <label class="text-surface-500 text-sm" for="title">Hmotnosť</label>
          <InputText id="title" v-model="state.weight" size="small"/>
        </div>

        <div class="flex flex-col mt-2 gap-1">
          <label class="text-surface-500 text-sm" for="title">Alergény</label>
          <InputText id="title" v-model="state.allergens" size="small"/>
        </div>

        <div class="flex flex-col mt-2 gap-1 shrink">
          <label class="text-surface-500 text-sm" for="title">Poradie</label>
          <InputText id="title" v-model="state.order" size="small"/>
        </div>

        <hr class="my-4 ">

        <div class="flex justify-between">
          <ToggleButton v-model="state.isNew" onLabel="Novinka" offLabel="Stála ponuka" size="sm"/>
          <ToggleButton v-model="state.active" onLabel="Aktívne" offLabel="Neaktívne" size="sm"/>
        </div>

      </div>
      <div class="flex flex-col pl-4 w-[460px] ">

        <!--        <div class="flex grow-0 flex-col mt-2 ">-->
        <!--          <b class="text-surface-500 text-sm" for="title">Vyberte typ</b>-->
        <!--          <div class="flex flex-col  mt-3 justify-center">-->
        <!--            <div v-for="category in MASTER_TYPES" :key="category.value" class="flex mr-4 mb-2 items-center">-->
        <!--              <RadioButton v-model="state.type" :inputId="category.value" name="dynamic" size="sm"-->
        <!--                           :value="category.value"/>-->
        <!--              <label :for="category.key" class="ml-2">{{ category.name }}</label>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->

        <div class="  mt-2">
          <b class="text-surface-500 text-sm">Vyberte položku v PLU </b>
          <MySelect v-model="state.pluItemId"
                    :options="selectedRestaurantPluItems"
                    placeholder="Vyberte položku v PLU"
                    class="w-full mt-1 "
                    :filter="true"
          />

        </div>
        <div class="  mt-2">

          <b class="text-surface-500 text-sm">Vyberte kategóriu</b>

          <MySelect v-model="state.categoryId"
                    :options="categoriesOptions"
                    placeholder="Vyberte kategoriu"
                    class="w-full mt-1 "
          />

        </div>
        <div class="  mt-2">
          <b class="text-surface-500 text-sm">Obal na jedlo</b>

          <MySelect v-model="state.foodPackaging"
                    :options="selectedRestaurantPluItems"
                    placeholder="Vyberte obal na jedlo"
                    class="w-full mt-1 "
          />

        </div>

        <div class="  mt-2">
          <b class="text-surface-500 text-sm">Záloha za produkt</b>

          <MySelect v-model="state.depositId"
                    :options="selectedRestaurantPluItems"
                    placeholder="Záloha za produkt"
                    class="w-full mt-1"
          />

        </div>

        <div class="  mt-2">
          <b class="text-surface-500 text-sm">Lietajúce časti</b>


          <div v-for="(part,i) in burgerParts" :key="part.id"
               class="flex py-1 border-b justify-between items-center gap-2">
            <div class="flex items-center">
              <Checkbox v-model="state.parts" :value="part.id" :inputId="part.id" :name="part.id"/>
              <label class="ml-2" :for="part.id"> {{ part.name }} </label>
            </div>
            <div class="flex items-center space-x-2">
              <font-awesome-icon @click="moveUp(i)" v-if="i > 0" :icon="['fas','arrow-up']"
                                 class=" hover:cursor-pointer p-1 text-primary-0"/>
              <font-awesome-icon @click="moveDown(i)" v-if="i < burgerParts.length - 1" :icon="['fas','arrow-down']"
                                 class=" hover:cursor-pointer p-1 text-primary-0"/>
            </div>
          </div>

        </div>


      </div>

      <div class="flex-1">

        <div class="mb-2">
          Obrázky
        </div>

        <input @change="imagedAdded($event)" ref="fileInput" type="file" style="display: none">

        <CreateOrEditProductImage v-for="(img,i) in state.images"
                                  :key="i"
                                  :img="img"
                                  @delete-image-on-index="deleteImageOnIndex(i)"
        />

        <div @click="addNewImage"
             class="w-full hover:cursor-pointer hover:bg-primary-100 border border-primary-300 rounded-xl flex items-center justify-center h-[120px] border-dashed">
          <span class="text-3xl">+</span>
        </div>

      </div>

    </div>

    <!--  footer -->
    <hr class="my-4">
    <div class="flex   " :class="isEdit ? 'justify-between':'justify-end'">
      <Button v-if="isEdit" @click="deleteThisProduct" :loading="deleting" type="button" size="small" label="Zmazať"
              severity="danger"
              class="self-start"
      ></Button>
      <div class="flex gap-2">
        <Button type="button" label="Zušiť" :disabled="loading || deleting" size="small" severity="secondary"
                @click="showModal = false"></Button>
        <Button @click="addNewProduct" :disabled="deleting" :loading="loading" size="small" label="Uložiť"
                icon="pi pi-check"
                iconPos="right"/>
      </div>
    </div>

  </Dialog>
</template>

<script>
import {reactive, ref} from "vue";
import {MASTER_TYPES} from "@/content/lists.js"

const EMPTY_PRODUCT = {
  restaurantPlace: 'BO',
  title: '',
  title_cz: '',
  title_en: '',
  title_de: '',
  text: '',
  text_cz: '',
  text_de: '',
  text_en: '',
  allergens: '',
  weight: '',
  order: 1,
  isNew: false,
  active: true,
  pluItemId: null,
  categoryId: null,
  foodPackaging: null,
  depositId: null,
  images: [],
  parts: [],
  type: MASTER_TYPES[0].value,
}

const showModal = ref(false)
const state = reactive({...EMPTY_PRODUCT})
const isEdit = ref(false)
let originalImages = []
const originalData = {}

export const openProduct = (values = null) => {
  console.log('openProduct', values)
  if (!values) {
    isEdit.value = false
    Object.assign(state, EMPTY_PRODUCT)
    originalImages = []
    delete state.id
  } else {
    isEdit.value = true
    // if (!values.parts) values.parts = []
    Object.assign(state, values)
    Object.assign(originalData, values)
    if (!!values?.images) originalImages = [...values.images]
    else originalImages = []
  }
  showModal.value = true
}

</script>

<script setup>
import {computed, reactive, ref, watch} from "vue";
import useContentStore from "@/stores/contentStore.js";
import Supabase from "@/utils/Supabase.js";
import {useToast} from "primevue/usetoast";
import {useConfirm} from "primevue/useconfirm";
import usePluStore from "@/stores/pluStore.js";
import {RESTAURANT_PLACES} from "@/content/lists.js";
import MySelect from "@/components/inputs/MySelect.vue";
import CreateOrEditProductImage from "@/components/views/CreateOrEditProductImage.vue";
import {deleteImageFromS3, uploadImageToS3} from "@/helpers/S3.js";
import {v4} from 'uuid'
import {isBase64} from "@/helpers/General.js";

const toast = useToast();
const confirm = useConfirm();

const options = ref([...RESTAURANT_PLACES]);

const pluStore = usePluStore()
const contentStore = useContentStore()

const loading = ref(false)

const selectedRestaurantPluItems = computed(() => state.restaurantPlace === 'BO' ? pluStore.pluItemsBo : pluStore.pluItemsPE)
const categoriesOptions = computed(() => [...contentStore.appCategories.filter(c => c.restaurantPlace === state.restaurantPlace).map(c => ({
  title: c.name + ' ' + c.restaurantPlace,
  value: c.id
})), {title: '-', value: null}])

const burgerParts = ref([...contentStore.flyParts.map(item => ({
  name: item.name_sk,
  id: item.id
}))])

// burgerParts.value item in index i move to new position i - 1
const moveUp = i => {
  if (i === 0) return
  const temp = burgerParts.value[i]
  burgerParts.value[i] = burgerParts.value[i - 1]
  burgerParts.value[i - 1] = temp
}
// burgerParts.value item in index i move to new position i + 1
const moveDown = i => {
  if (i === burgerParts.value.length - 1) return
  const temp = burgerParts.value[i]
  burgerParts.value[i] = burgerParts.value[i + 1]
  burgerParts.value[i + 1] = temp
}


const fileInput = ref(null)

const addNewImage = () => fileInput.value?.click()

const imagedAdded = e => {

  const file = e.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = () => {
    const base64String = reader.result;
    state.images.push(base64String)
    fileInput.value = '';
  };

  reader.onerror = () => {
    alert('Error');
    fileInput.value = '';
  }

  reader.readAsDataURL(file);

}

const deleteImageOnIndex = (index) => {
  if (!window.confirm('Si si istý že chceš zmazať tento obrázok?')) return
  state.images = state.images.filter((img, i) => i !== index)
}

const addNewProduct = async () => {

  loading.value = true
  const {images} = state
  const product = {...state}
  delete product.images
  delete product['pluItem']

  const partsData = []
  const parts = state.parts ?? []
  for (let singlePart of burgerParts.value) {
    if (parts.includes(singlePart.id)) {
      partsData.push(singlePart.id)
    }
  }

  product['parts'] = partsData
  console.log('product', product)
  // return

  if (isEdit.value && originalData.restaurantPlace !== product.restaurantPlace) {
    // delete product.id
  }

  const query = async () => {
    if (!isEdit.value) return Supabase.from('v2_Hajcer_App_Products').insert({
      ...product
    }).select().single()
    else return Supabase.from('v2_Hajcer_App_Products').update({
      ...product
    }).eq('id', state.id).select().single()
  }

  const {data, error} = await query()

  if (error) {
    toast.add({severity: 'error', summary: 'Error', detail: error.message});
    loading.value = false
    return
  }
  toast.add({severity: 'success', summary: 'Success', detail: 'Product success', life: 3000});

  const productId = data.id
  const deletedImages = originalImages.filter(img => !images.includes(img))
  const imagesNameToUpdate = []
  let hasErrorUploadImages = false

  for (const img of images) {

    if (!isBase64(img)) {
      imagesNameToUpdate.push(img)
      continue
    }

    const ext = img.split(';')[0].split('/')[1]
    const name = `${v4()}.${ext}`

    const success = await uploadImageToS3(img, 'app-products-images', name)
    if (success) {
      imagesNameToUpdate.push(name)
    } else {
      hasErrorUploadImages = true
    }
  }

  for (const img of deletedImages) {
    await deleteImageFromS3('app-products-images', img)
  }

  if (hasErrorUploadImages) {
    toast.add({severity: 'error', summary: 'Error', detail: 'Error uploading images', life: 3000});
  }

  const {
    data: updateProductIMages,
    error: errorUpdateProductIMages
  } = await Supabase.from('v2_Hajcer_App_Products').update({images: imagesNameToUpdate}).eq('id', productId)

  if (errorUpdateProductIMages) {
    toast.add({severity: 'error', summary: 'Error', detail: errorUpdateProductIMages.message, life: 3000});
  }

  await contentStore.loadProducts()

  loading.value = false
  showModal.value = false

}

watch(showModal, (val) => {
  if (!val) {
    state.images = []
    fileInput.value = null
  }
})

const deleting = ref(false)
const deleteThisProduct = () => {
  confirm.require({
    message: 'Do you want to delete this record?',
    header: 'Danger Zone',
    icon: 'pi pi-info-circle',
    rejectLabel: 'Cancel',
    rejectProps: {
      label: 'Cancel',
      severity: 'secondary',
      outlined: true
    },
    acceptProps: {
      label: 'Delete',
      severity: 'danger'
    },
    accept: async () => {
      deleting.value = true
      const {data, error} = await Supabase.from('v2_Hajcer_App_Products').delete().eq('id', state.id)
      if (error) {
        toast.add({severity: 'error', summary: 'Error', detail: error.message, life: 3000});
      } else {

        for (const img of originalImages) {
          await deleteImageFromS3('app-products-images', img)
        }

        toast.add({severity: 'success', summary: 'Success', detail: 'Product deleted', life: 3000});
        await contentStore.loadProducts()
      }
      deleting.value = false
      showModal.value = false
    },
    reject: async () => {
      toast.add({severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000});
    }
  });
}


</script>